import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  selectTag: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 290
  },
  select: {
    maxWidth: 390,
    width: '100%'
  }
}))
